<template>
  <v-dialog
    v-model="show"
    width="60vw"
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
    scrollable
    persistent
  >
    <v-card
      height="auto"
      elevation="0"
      class="rounded-lg"
      min-height="200"
      v-if="loteSelected"
    >
      <v-card-title class="text-h5 lighten-2" v-if="loteSelected">
        <v-row no-gutters>
          <v-col cols="12"> Actualizar lote {{ loteSelected.loteId }} </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1"
              > {{ loteSelected.identificationName }}</span
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            v-if="
              loteSelected.productionState !== 'USELESS' &&
              loteSelected.productionState !== 'DISCARDED'
            "
          >
            <v-col align="end">
              <v-btn
                small
                rounded
                color="red"
                dark
                @click="showGenericConfirmationModalDeleteLote = true"
              >
                <v-icon> mdi-trash-can </v-icon>
                Descartar lote por contaminación
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="
              loteSelected.productionState !== 'USELESS' &&
              loteSelected.productionState !== 'DISCARDED'
            "
          >
            <v-col align="end">
              <v-btn
                small
                rounded
                color="warning"
                dark
                @click="showDiscardLoteModal = true"
              >
                <v-icon>mdi-delete-variant</v-icon>
                Desechar lote
              </v-btn>
            </v-col>
          </v-row>
          <v-stepper v-model="stepper" vertical non-linear elevation="0">
            <v-stepper-step
              step="1"
              editable
              :complete="loteSelected.productionState != 'PREINOCULATE'"
            >
              Preinóculo</v-stepper-step
            >
            <v-stepper-content step="1">
              <v-container fluid>
                <v-row>
                  <v-col v-if="loteSelected.endPreinoculateDate">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Preinóculo producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>Preinóculo producción en proceso...</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          validaciones
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form
                            ref="formPreinoculateValidation"
                            lazy-validation
                          >
                            <div>
                              <v-tabs v-model="currentFlaskTab" show-arrows>
                                <v-tab
                                  v-for="(flask, index) in loteSelected.flasks"
                                  :key="index"
                                >
                                  {{ flask.name }}
                                  <v-icon
                                    v-if="flask.isApproved == false"
                                    small
                                    color="error"
                                    class="ml-1"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="currentFlaskTab">
                                <v-tab-item
                                  v-for="(flask, index) in loteSelected.flasks"
                                  :key="index"
                                >
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" xl="6" lg="6">
                                        <v-combobox
                                          v-model="flask.staining"
                                          outlined
                                          clearable
                                          label="Resultado tincion"
                                          dense
                                          :items="staining"
                                          :rules="validation('Tincion')"
                                          :disabled="
                                            loteSelected.isValidationPreinoculate
                                          "
                                        ></v-combobox>
                                      </v-col>

                                      <v-col cols="12" xl="6" lg="6">
                                        <v-text-field
                                          v-model="flask.concentration"
                                          type="text"
                                          outlined
                                          clearable
                                          label="Introduce UFC/ml"
                                          dense
                                          :rules="validation('concentración')"
                                          :disabled="
                                            loteSelected.isValidationPreinoculate
                                          "
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-row>
                                          <v-col>
                                            <v-card elevation="2">
                                              <v-card-text>
                                                <v-container>
                                                  <v-row>
                                                    <v-col>
                                                      <span
                                                        >{{ flask.name }}
                                                        <div
                                                          v-if="
                                                            flask.isApproved ==
                                                            false
                                                          "
                                                        >
                                                          <span
                                                            class="text-caption red--text"
                                                            >(Descartado)</span
                                                          >
                                                        </div>
                                                      </span>
                                                    </v-col>
                                                  </v-row>

                                                  <v-row>
                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                    >
                                                      <span
                                                        >Presencia de
                                                        contaminación</span
                                                      >
                                                      <v-spacer></v-spacer>
                                                      <v-radio-group
                                                        v-model="
                                                          flask.isContaminated
                                                        "
                                                        row
                                                        :disabled="
                                                          loteSelected.isValidationPreinoculate
                                                        "
                                                      >
                                                        <v-radio
                                                          :value="true"
                                                          label="Presentes"
                                                        ></v-radio>
                                                        <v-radio
                                                          :value="false"
                                                          label="Ausentes"
                                                        ></v-radio>
                                                      </v-radio-group>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                      v-if="
                                                        flask.isContaminated
                                                      "
                                                    >
                                                      <v-combobox
                                                        v-model="
                                                          flask.reasonForContamination
                                                        "
                                                        :items="contaminations"
                                                        outlined
                                                        dense
                                                        label="Selecciona motivo de contaminación"
                                                        :disabled="
                                                          loteSelected.isValidationPreinoculate
                                                        "
                                                        :rules="validation()"
                                                      ></v-combobox>
                                                      <v-textarea
                                                        v-if="
                                                          flask.reasonForContamination &&
                                                          flask
                                                            .reasonForContamination
                                                            .value == 'OTHER'
                                                        "
                                                        :disabled="
                                                          loteSelected.isValidationPreinoculate
                                                        "
                                                        outlined
                                                        dense
                                                        label="Descripción de contaminación"
                                                        v-model="
                                                          flask.contaminationDescription
                                                        "
                                                      ></v-textarea>
                                                    </v-col>

                                                    <v-col cols="12">
                                                      <v-row>
                                                        <v-col>
                                                          <span
                                                            >Morfologia
                                                            colonial</span
                                                          >
                                                        </v-col>
                                                      </v-row>

                                                      <v-row>
                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .shape
                                                            "
                                                            :items="shape"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Forma"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'forma',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .margin
                                                            "
                                                            :items="margin"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Borde"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'borde',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .elevation
                                                            "
                                                            :items="elevation"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Elevación"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'elevación',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .surface
                                                            "
                                                            :rules="
                                                              flask.isContaminated
                                                                ? [() => true]
                                                                : [
                                                                    () =>
                                                                      flask
                                                                        .morphology
                                                                        .surface
                                                                        .length >
                                                                        0 ||
                                                                      'La superficie requerida',
                                                                  ]
                                                            "
                                                            :items="surface"
                                                            multiple
                                                            outlined
                                                            dense
                                                            required
                                                            label="Superficie"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                          >
                                                            <template
                                                              v-slot:selection="{
                                                                item,
                                                                index,
                                                              }"
                                                            >
                                                              <span
                                                                v-if="
                                                                  index === 0
                                                                "
                                                                class="mr-2"
                                                                >{{
                                                                  item.text
                                                                }}</span
                                                              >
                                                              <span
                                                                v-if="
                                                                  index === 1
                                                                "
                                                                class="grey--text caption"
                                                              >
                                                                ({{
                                                                  flask
                                                                    .morphology
                                                                    .surface
                                                                    .length - 1
                                                                }}
                                                                más)
                                                              </span>
                                                            </template>
                                                          </v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .opacity
                                                            "
                                                            :items="opacity"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Opacidad"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'opacidad',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .color
                                                            "
                                                            :items="color"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Color"
                                                            :disabled="
                                                              loteSelected.isValidationPreinoculate
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'color',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>
                                                      </v-row>
                                                    </v-col>
                                                  </v-row>
                                                </v-container>
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea
                                          v-model="flask.observations"
                                          outlined
                                          name="input-7-4"
                                          label="Observaciones"
                                          dense
                                          :disabled="
                                            loteSelected.isValidationPreinoculate
                                          "
                                        ></v-textarea>
                                      </v-col>
                                      <v-col cols="12" xl="6" lg="6" md="6">
                                        <span class="text-body-1"
                                          >¿Esta aprobado por calidad?</span
                                        >
                                        <v-spacer></v-spacer>
                                        <v-radio-group
                                          v-model="flask.isApproved"
                                          row
                                          :disabled="
                                            loteSelected.isValidationPreinoculate
                                          "
                                          :rules="[
                                            (v) =>
                                              flask.isApproved != undefined ||
                                              `El campo es obligatorio.`,
                                          ]"
                                        >
                                          <v-radio
                                            :value="true"
                                            label="Pasa"
                                          ></v-radio>
                                          <v-radio
                                            :value="false"
                                            label="No pasa"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-tab-item>
                              </v-tabs-items>
                            </div>
                            <v-row
                              justify="end"
                              v-if="showAdviceMFPreinoculate"
                            >
                              <v-col align="end">
                                <span class="red--text"
                                  >*{{ messageAdviceMFPreinoculate }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row
                              align="center"
                              justify="end"
                              v-if="!loteSelected.isValidationPreinoculate"
                            >
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="gray"
                                  dark
                                  block
                                  @click="saveDataPreinoculateValidationRequest"
                                >
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="primary"
                                  dark
                                  block
                                  @click="finishPreinoculateRequest"
                                  >Pasar a inóculo
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="2"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED'
              "
              v-if="
                loteSelected.endPreinoculateDate != undefined &&
                loteSelected.dosesStart > 2
              "
            >
              Inóculo</v-stepper-step
            >
            <v-stepper-content step="2">
              <v-container fluid>
                <v-row>
                  <v-col v-if="loteSelected.endInoculateeDate ? true : false">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En espera de producción...</span>
                  </v-col>
                </v-row>
                <v-row
                  class="text-end py-2"
                  v-if="loteSelected.isValidationPreinoculate"
                >
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="loteSelected.isStartedInoculate"
                      @click="showConfirmattionUndoFinishPreinoculate = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Deshacer Preinóculo
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          validaciones
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form ref="formInoculateValidation" lazy-validation>
                            <div>
                              <v-tabs v-model="currentJarTab" show-arrows>
                                <v-tab
                                  v-for="(jar, index) in loteSelected.jars"
                                  :key="index"
                                >
                                  {{ jar.name }}
                                  <v-icon
                                    v-if="jar.isApproved == false"
                                    small
                                    color="error"
                                    class="ml-1"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </v-tab>
                              </v-tabs>

                              <v-tabs-items v-model="currentJarTab">
                                <v-tab-item
                                  v-for="(jar, index) in loteSelected.jars"
                                  :key="index"
                                >
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" xl="6" lg="6">
                                        <v-combobox
                                          v-model="jar.staining"
                                          outlined
                                          clearable
                                          label="Resultado tincion"
                                          dense
                                          :items="staining"
                                          :rules="validation('Tincion')"
                                          :disabled="
                                            loteSelected.isStartedInoculate
                                          "
                                        ></v-combobox>
                                      </v-col>

                                      <v-col cols="12" xl="6" lg="6">
                                        <v-text-field
                                          v-model="jar.concentration"
                                          type="text"
                                          outlined
                                          clearable
                                          label="Introduce UFC/ml"
                                          dense
                                            :rules="validation('concentración')"
                                          :disabled="
                                            loteSelected.isStartedInoculate
                                          "
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-row>
                                          <v-col>
                                            <v-card elevation="2">
                                              <v-card-text>
                                                <v-container>
                                                  <v-row>
                                                    <v-col>
                                                      <span
                                                        >{{ jar.name }}
                                                        <div
                                                          v-if="
                                                            jar.isApproved ==
                                                            false
                                                          "
                                                        >
                                                          <span
                                                            class="text-caption red--text"
                                                            >(Descartado)</span
                                                          >
                                                        </div>
                                                      </span>
                                                    </v-col>
                                                  </v-row>

                                                  <v-row>
                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                    >
                                                      <span
                                                        >Presencia de
                                                        contaminación</span
                                                      >
                                                      <v-spacer></v-spacer>
                                                      <v-radio-group
                                                        v-model="
                                                          jar.isContaminated
                                                        "
                                                        row
                                                        :disabled="
                                                          loteSelected.isStartedInoculate
                                                        "
                                                      >
                                                        <v-radio
                                                          :value="true"
                                                          label="Presentes"
                                                        ></v-radio>
                                                        <v-radio
                                                          :value="false"
                                                          label="Ausentes"
                                                        ></v-radio>
                                                      </v-radio-group>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                      v-if="jar.isContaminated"
                                                    >
                                                      <v-combobox
                                                        v-model="
                                                          jar.reasonForContamination
                                                        "
                                                        :items="contaminations"
                                                        outlined
                                                        :disabled="
                                                          loteSelected.isStartedInoculate
                                                        "
                                                        dense
                                                        label="Selecciona motivo de contaminación"
                                                        :rules="validation()"
                                                      ></v-combobox>
                                                      <v-textarea
                                                        v-if="
                                                          jar.reasonForContamination &&
                                                          jar
                                                            .reasonForContamination
                                                            .value == 'OTHER'
                                                        "
                                                        :disabled="
                                                          loteSelected.isStartedInoculate
                                                        "
                                                        outlined
                                                        dense
                                                        label="Descripción de contaminación"
                                                        v-model="
                                                          jar.contaminationDescription
                                                        "
                                                      ></v-textarea>
                                                    </v-col>

                                                    <v-col cols="12">
                                                      <v-row>
                                                        <v-col>
                                                          <span
                                                            >Morfologia
                                                            colonial</span
                                                          >
                                                        </v-col>
                                                      </v-row>

                                                      <v-row>
                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .shape
                                                            "
                                                            :items="shape"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Forma"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'forma',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .margin
                                                            "
                                                            :items="margin"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Borde"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'borde',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .elevation
                                                            "
                                                            :items="elevation"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Elevación"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'elevación',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .surface
                                                            "
                                                            :rules="
                                                              jar.isContaminated
                                                                ? [() => true]
                                                                : [
                                                                    () =>
                                                                      jar
                                                                        .morphology
                                                                        .surface
                                                                        .length >
                                                                        0 ||
                                                                      'La superficie requerida',
                                                                  ]
                                                            "
                                                            :items="surface"
                                                            multiple
                                                            outlined
                                                            dense
                                                            required
                                                            label="Superficie"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                          >
                                                            <template
                                                              v-slot:selection="{
                                                                item,
                                                                index,
                                                              }"
                                                            >
                                                              <span
                                                                v-if="
                                                                  index === 0
                                                                "
                                                                class="mr-2"
                                                                >{{
                                                                  item.text
                                                                }}</span
                                                              >
                                                              <span
                                                                v-if="
                                                                  index === 1
                                                                "
                                                                class="grey--text caption"
                                                              >
                                                                ({{
                                                                  jar.morphology
                                                                    .surface
                                                                    .length - 1
                                                                }}
                                                                más)
                                                              </span>
                                                            </template>
                                                          </v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .opacity
                                                            "
                                                            :items="opacity"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Opacidad"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'opacidad',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .color
                                                            "
                                                            :items="color"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Color"
                                                            :disabled="
                                                              loteSelected.isStartedInoculate
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'color',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>
                                                      </v-row>
                                                    </v-col>
                                                  </v-row>
                                                </v-container>
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea
                                          v-model="jar.observations"
                                          outlined
                                          name="input-7-4"
                                          label="Observaciones"
                                          dense
                                          :disabled="
                                            loteSelected.isStartedInoculate
                                          "
                                        ></v-textarea>
                                      </v-col>
                                      <v-col cols="12" xl="6" lg="6" md="6">
                                        <span class="text-body-1"
                                          >¿Esta aprobado por calidad?</span
                                        >
                                        <v-spacer></v-spacer>
                                        <v-radio-group
                                          v-model="jar.isApproved"
                                          row
                                          :disabled="
                                            loteSelected.isStartedInoculate
                                          "
                                          :rules="[
                                            (v) =>
                                              jar.isApproved != undefined ||
                                              `El campo es obligatorio.`,
                                          ]"
                                        >
                                          <v-radio
                                            :value="true"
                                            label="Pasa"
                                          ></v-radio>
                                          <v-radio
                                            :value="false"
                                            label="No pasa"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-tab-item>
                              </v-tabs-items>
                            </div>
                            <v-row justify="end" v-if="showMFAdviceInoculate">
                              <v-col align="end">
                                <span class="red--text"
                                  >* {{ messageMFAdviceInoculate }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row
                              align="center"
                              justify="end"
                              v-if="!loteSelected.isStartedInoculate"
                            >
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="gray"
                                  dark
                                  block
                                  @click="saveInoculateRequest"
                                >
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="primary"
                                  dark
                                  block
                                  @click="finishInoculateRequest()"
                                  >Pasar a semilla
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="3"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED' &&
                loteSelected.productionState != 'SEED'
              "
              v-if="loteSelected.endInoculateeDate"
            >
              Semilla</v-stepper-step
            >
            <v-stepper-content step="3">
              <v-container fluid>
                <v-row>
                  <v-col v-if="loteSelected.isStartedSeed">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En espera de producción...</span>
                  </v-col>
                </v-row>
                <v-row
                  class="text-end py-2"
                  v-if="loteSelected.isStartedInoculate"
                >
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="!!loteSelected.endSeedValidations"
                      @click="showConfirmattionUndoFinishInoculate = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Deshacer Inóculo
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          validaciones
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form ref="formSeedValidations" lazy-validation>
                            <div>
                              <v-tabs v-model="currentSeedJarTab" show-arrows>
                                <v-tab
                                  v-for="(jar, index) in loteSelected.jarsSeed"
                                  :key="index"
                                >
                                  {{ jar.name }}
                                  <v-icon
                                    v-if="jar.isApproved == false"
                                    small
                                    color="error"
                                    class="ml-1"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="currentSeedJarTab">
                                <v-tab-item
                                  v-for="(jar, index) in loteSelected.jarsSeed"
                                  :key="index"
                                >
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" xl="6" lg="6">
                                        <v-combobox
                                          v-model="jar.staining"
                                          outlined
                                          clearable
                                          label="Resultado tincion"
                                          dense
                                          :items="staining"
                                          :rules="validation('Tincion')"
                                          :disabled="
                                            !!loteSelected.endSeedValidations
                                          "
                                        ></v-combobox>
                                      </v-col>

                                      <v-col cols="12" xl="6" lg="6">
                                        <v-text-field
                                          v-model="jar.concentration"
                                          type="text"
                                          outlined
                                          clearable
                                          label="Introduce UFC/ml"
                                          dense
                                            :rules="validation('concentración')"
                                          :disabled="
                                            !!loteSelected.endSeedValidations
                                          "
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-row>
                                          <v-col>
                                            <v-card elevation="2">
                                              <v-card-text>
                                                <v-container>
                                                  <v-row>
                                                    <v-col>
                                                      <span
                                                        >{{ jar.name }}
                                                        <div
                                                          v-if="
                                                            jar.isApproved ==
                                                            false
                                                          "
                                                        >
                                                          <span
                                                            class="text-caption red--text"
                                                            >(Descartado)</span
                                                          >
                                                        </div>
                                                      </span>
                                                    </v-col>
                                                  </v-row>

                                                  <v-row>
                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                    >
                                                      <span
                                                        >Presencia de
                                                        contaminación</span
                                                      >
                                                      <v-spacer></v-spacer>
                                                      <v-radio-group
                                                        v-model="
                                                          jar.isContaminated
                                                        "
                                                        row
                                                        :disabled="
                                                          !!loteSelected.endSeedValidations
                                                        "
                                                      >
                                                        <v-radio
                                                          :value="true"
                                                          label="Presentes"
                                                        ></v-radio>
                                                        <v-radio
                                                          :value="false"
                                                          label="Ausentes"
                                                        ></v-radio>
                                                      </v-radio-group>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                      v-if="jar.isContaminated"
                                                    >
                                                      <v-combobox
                                                        v-model="
                                                          jar.reasonForContamination
                                                        "
                                                        :items="contaminations"
                                                        outlined
                                                        dense
                                                        label="Selecciona motivo de contaminación"
                                                        :disabled="
                                                          !!loteSelected.endSeedValidations
                                                        "
                                                        :rules="validation()"
                                                      ></v-combobox>
                                                      <v-textarea
                                                        v-if="
                                                          jar.reasonForContamination &&
                                                          jar
                                                            .reasonForContamination
                                                            .value == 'OTHER'
                                                        "
                                                        :disabled="
                                                          !!loteSelected.endSeedValidations
                                                        "
                                                        outlined
                                                        dense
                                                        label="Descripción de contaminación"
                                                        v-model="
                                                          jar.contaminationDescription
                                                        "
                                                      ></v-textarea>
                                                    </v-col>

                                                    <v-col cols="12">
                                                      <v-row>
                                                        <v-col>
                                                          <span
                                                            >Morfologia
                                                            colonial</span
                                                          >
                                                        </v-col>
                                                      </v-row>

                                                      <v-row>
                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .shape
                                                            "
                                                            :items="shape"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Forma"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'forma',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .margin
                                                            "
                                                            :items="margin"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Borde"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'borde',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .elevation
                                                            "
                                                            :items="elevation"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Elevación"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'elevación',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .surface
                                                            "
                                                            :rules="
                                                              jar.isContaminated
                                                                ? [() => true]
                                                                : [
                                                                    () =>
                                                                      jar
                                                                        .morphology
                                                                        .surface
                                                                        .length >
                                                                        0 ||
                                                                      'La superficie requerida',
                                                                  ]
                                                            "
                                                            :items="surface"
                                                            multiple
                                                            outlined
                                                            dense
                                                            required
                                                            label="Superficie"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                          >
                                                            <template
                                                              v-slot:selection="{
                                                                item,
                                                                index,
                                                              }"
                                                            >
                                                              <span
                                                                v-if="
                                                                  index === 0
                                                                "
                                                                class="mr-2"
                                                                >{{
                                                                  item.text
                                                                }}</span
                                                              >
                                                              <span
                                                                v-if="
                                                                  index === 1
                                                                "
                                                                class="grey--text caption"
                                                              >
                                                                ({{
                                                                  jar.morphology
                                                                    .surface
                                                                    .length - 1
                                                                }}
                                                                más)
                                                              </span>
                                                            </template>
                                                          </v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              jar.morphology
                                                                .opacity
                                                            "
                                                            :items="opacity"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Opacidad"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'opacidad',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            v-model="
                                                              jar.morphology
                                                                .color
                                                            "
                                                            :items="color"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Color"
                                                            :disabled="
                                                              !!loteSelected.endSeedValidations
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'color',
                                                                jar.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>
                                                      </v-row>
                                                    </v-col>
                                                  </v-row>
                                                </v-container>
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea
                                          v-model="jar.observations"
                                          outlined
                                          name="input-7-4"
                                          label="Observaciones"
                                          dense
                                          :disabled="
                                            !!loteSelected.endSeedValidations
                                          "
                                        ></v-textarea>
                                      </v-col>
                                      <v-col cols="12" xl="6" lg="6" md="6">
                                        <span class="text-body-1"
                                          >¿Esta aprobado por calidad?</span
                                        >
                                        <v-spacer></v-spacer>
                                        <v-radio-group
                                          v-model="jar.isApproved"
                                          row
                                          :disabled="
                                            loteSelected.endSeedValidations
                                          "
                                          :rules="[
                                            (v) =>
                                              jar.isApproved != undefined ||
                                              `El campo es obligatorio.`,
                                          ]"
                                        >
                                          <v-radio
                                            :value="true"
                                            label="Pasa"
                                          ></v-radio>
                                          <v-radio
                                            :value="false"
                                            label="No pasa"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-tab-item>
                              </v-tabs-items>
                            </div>
                            <v-row justify="end" v-if="showAdviceMFSeed">
                              <v-col align="end">
                                <span class="red--text"
                                  >* {{ messageAdviceMFSeed }}
                                </span>
                              </v-col>
                            </v-row>
                            <v-row
                              align="center"
                              justify="end"
                              v-if="
                                loteSelected.endSeedValidations == undefined
                              "
                            >
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="gray"
                                  dark
                                  block
                                  @click="saveSeedRequest"
                                >
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="primary"
                                  dark
                                  block
                                  @click="endSeedRequest"
                                  >Validar
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <v-row v-if="!!loteSelected.endSeedValidations">
                  <v-col v-if="!!loteSelected.endSeedDate">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>Semilla producción en proceso...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="4"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED' &&
                loteSelected.productionState != 'SEED' &&
                loteSelected.productionState != 'FERMENTATION'
              "
              v-if="loteSelected.endSeedDate ? true : false"
            >
              <span v-if="loteSelected.productionType.value == 'mr'">
                {{ loteSelected.productionType.text }}
              </span>
              <span v-else>
                Fermentación ({{ loteSelected.productionType.text }})
              </span>
            </v-stepper-step>
            <v-stepper-content step="4">
              <v-container
                v-if="
                  loteSelected.productionType &&
                  loteSelected.productionType.value == 'reactor'
                "
              >
                <v-row>
                  <v-col
                    v-if="
                      loteSelected.isReadyToValidateFermentationReactorSimple
                    "
                  >
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>Producción en proceso...</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Esterilización reactor: </span>
                  </v-col>
                </v-row>
                <v-form
                  ref="formReactorFermentationSterilizationQuality"
                  lazy-validation
                >
                  <v-row
                    v-if="
                      loteSelected.isReadyToValidateFermentationReactorSimple
                    "
                  >
                    <v-col cols="12" xl="6" lg="6">
                      <v-text-field
                        v-model="loteSelected.reactorSterilizationDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de esterilizado de reactor"
                        dense
                        :rules="validation('Fecha')"
                        :disabled="
                          loteSelected.isReadyToValidateFermentationReactorSimple
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="auto">
                      <v-radio-group
                        v-model="
                          loteSelected.reactorFermentationSterilizationQuality
                        "
                        row
                        :disabled="
                          loteSelected.isDoneReactorFermentationSterilizationQuality
                        "
                        :rules="[
                          (v) =>
                            loteSelected.reactorFermentationSterilizationQuality !=
                              undefined || `El campo es obligatorio.`,
                        ]"
                      >
                        <v-radio :value="true" label="Cumple"></v-radio>
                        <v-radio :value="false" label="No cumple"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        label="Observaciones de esterilización"
                        v-model="
                          loteSelected.reactorFermentationSterilizationQualityObservations
                        "
                        :disabled="
                          loteSelected.isDoneReactorFermentationSterilizationQuality
                        "
                        outlined
                        dense
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" class="text-end">
                      <v-btn
                        color="primary"
                        :disabled="
                          loteSelected.isDoneReactorFermentationSterilizationQuality
                        "
                        @click="endReactorFermentationSterilizationQuality"
                        >Guardar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
                <div
                  v-if="
                    loteSelected.isReadyToValidateFermentationReactorSimple &&
                    !loteSelected.isFeedable
                  "
                >
                  <v-row>
                    <v-col cols="12">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            validación tiempo final
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-form ref="formValidationEndTime" lazy-validation>
                              <v-row>
                                <v-col cols="12" xl="6" lg="6" class="pa-1">
                                  <v-combobox
                                    v-model="loteSelected.stainingEndTime"
                                    outlined
                                    clearable
                                    label="Resultado tincion"
                                    dense
                                    :items="staining"
                                    :rules="validation('Tincion')"
                                    :disabled="
                                      loteSelected.isEndTimeValidationReady
                                    "
                                  ></v-combobox>
                                </v-col>
                                <v-col cols="12" xl="6" lg="6" class="pa-1">
                                  <v-text-field
                                    v-model="loteSelected.ufcEndTime"
                                    type="number"
                                    outlined
                                    clearable
                                    label="Introduce UFC/ml"
                                    dense
                                      :rules="validation('concentración')"
                                    :disabled="
                                      loteSelected.isEndTimeValidationReady
                                    "
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col>
                                      <v-card elevation="2">
                                        <v-card-text>
                                          <v-container>
                                            <v-row>
                                              <v-col>
                                                <span v-if="validationEndTime"
                                                  >Muestra final
                                                  <div
                                                    v-if="
                                                      validationEndTime.isApproved ==
                                                      false
                                                    "
                                                  >
                                                    <span
                                                      class="text-caption red--text"
                                                      >(Descartado)</span
                                                    >
                                                  </div>
                                                </span>
                                                <span v-else>Matraz -</span>
                                              </v-col>
                                            </v-row>
                                            <v-row v-if="validationEndTime">
                                              <v-col
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                              >
                                                <span
                                                  >Presencia de
                                                  contaminación</span
                                                >
                                                <v-spacer></v-spacer>
                                                <v-radio-group
                                                  v-model="
                                                    validationEndTime.isContaminated
                                                  "
                                                  :disabled="
                                                    loteSelected.isEndTimeValidationReady
                                                  "
                                                  row
                                                >
                                                  <v-radio
                                                    :value="true"
                                                    label="Presentes"
                                                  ></v-radio>
                                                  <v-radio
                                                    :value="false"
                                                    label="Ausentes"
                                                  ></v-radio>
                                                </v-radio-group>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                                v-if="
                                                  validationEndTime.isContaminated
                                                "
                                              >
                                                <v-combobox
                                                  v-model="
                                                    validationEndTime.reasonForContamination
                                                  "
                                                  :items="contaminations"
                                                  outlined
                                                  dense
                                                  label="Selecciona motivo de contaminación"
                                                  :disabled="
                                                    loteSelected.isEndTimeValidationReady
                                                  "
                                                  :rules="validation()"
                                                >
                                                </v-combobox>
                                                <v-textarea
                                                  v-if="
                                                    validationEndTime.reasonForContamination &&
                                                    validationEndTime
                                                      .reasonForContamination
                                                      .value == 'OTHER'
                                                  "
                                                  :disabled="
                                                    loteSelected.isEndTimeValidationReady
                                                  "
                                                  outlined
                                                  dense
                                                  label="Descripción de contaminación"
                                                  v-model="
                                                    validationEndTime.contaminationDescription
                                                  "
                                                ></v-textarea>
                                              </v-col>
                                              <v-col cols="12">
                                                <v-row>
                                                  <v-col>
                                                    <span
                                                      >Morfologia colonial
                                                    </span>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="6">
                                                    <v-select
                                                      clearable
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.shape
                                                      "
                                                      :items="shape"
                                                      outlined
                                                      dense
                                                      required
                                                      label="Forma"
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      :rules="
                                                        validationConditionalF(
                                                          'forma',
                                                          validationEndTime.isContaminated
                                                        )
                                                      "
                                                    ></v-select>
                                                    <v-select
                                                      clearable
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.margin
                                                      "
                                                      :items="margin"
                                                      outlined
                                                      dense
                                                      required
                                                      label="Borde"
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      :rules="
                                                        validationConditional(
                                                          'borde',
                                                          validationEndTime.isContaminated
                                                        )
                                                      "
                                                    ></v-select>
                                                    <v-select
                                                      clearable
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.elevation
                                                      "
                                                      :items="elevation"
                                                      outlined
                                                      dense
                                                      required
                                                      label="Elevación"
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      :rules="
                                                        validationConditionalF(
                                                          'elevación',
                                                          validationEndTime.isContaminated
                                                        )
                                                      "
                                                    ></v-select>
                                                  </v-col>
                                                  <v-col cols="12" sm="6">
                                                    <v-select
                                                      clearable
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.surface
                                                      "
                                                      :rules="
                                                        validationEndTime.isContaminated
                                                          ? [() => true]
                                                          : [
                                                              () =>
                                                                validationEndTime
                                                                  .morphology
                                                                  .surface
                                                                  .length > 0 ||
                                                                'La superficie requerida',
                                                            ]
                                                      "
                                                      :items="surface"
                                                      multiple
                                                      outlined
                                                      dense
                                                      required
                                                      label="Superficie"
                                                    >
                                                      <template
                                                        v-slot:selection="{
                                                          item,
                                                          index,
                                                        }"
                                                      >
                                                        <span
                                                          v-if="index === 0"
                                                          class="mr-2"
                                                          >{{ item.text }}</span
                                                        >
                                                        <span
                                                          v-if="index === 1"
                                                          class="grey--text caption"
                                                        >
                                                          ({{
                                                            validationEndTime
                                                              .morphology
                                                              .surface.length -
                                                            1
                                                          }}
                                                          más)
                                                        </span>
                                                      </template>
                                                    </v-select>
                                                    <v-select
                                                      clearable
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.opacity
                                                      "
                                                      :items="opacity"
                                                      outlined
                                                      dense
                                                      required
                                                      label="Opacidad"
                                                      :rules="
                                                        validationConditionalF(
                                                          'opacidad',
                                                          validationEndTime.isContaminated
                                                        )
                                                      "
                                                    ></v-select>
                                                    <v-select
                                                      clearable
                                                      :disabled="
                                                        loteSelected.isEndTimeValidationReady
                                                      "
                                                      v-model="
                                                        validationEndTime
                                                          .morphology.color
                                                      "
                                                      :items="color"
                                                      outlined
                                                      dense
                                                      required
                                                      label="Color"
                                                      :rules="
                                                        validationConditional(
                                                          'color',
                                                          validationEndTime.isContaminated
                                                        )
                                                      "
                                                    ></v-select>
                                                  </v-col>
                                                </v-row>
                                              </v-col>
                                              <v-col cols="12">
                                                <v-textarea
                                                  v-model="
                                                    validationEndTime.observations
                                                  "
                                                  outlined
                                                  name="input-7-4"
                                                  label="Observaciones"
                                                  dense
                                                  :disabled="
                                                    loteSelected.isEndTimeValidationReady
                                                  "
                                                ></v-textarea>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="6"
                                                lg="6"
                                                md="6"
                                              >
                                                <span class="text-body-1"
                                                  >¿Esta aprobado por
                                                  calidad?</span
                                                >
                                                <v-spacer></v-spacer>
                                                <v-radio-group
                                                  v-model="
                                                    validationEndTime.isApproved
                                                  "
                                                  row
                                                  :disabled="
                                                    loteSelected.isEndTimeValidationReady
                                                  "
                                                  :rules="[
                                                    (v) =>
                                                      validationEndTime.isApproved !=
                                                        undefined ||
                                                      `El campo es obligatorio.`,
                                                  ]"
                                                >
                                                  <v-radio
                                                    :value="true"
                                                    label="Pasa"
                                                  ></v-radio>
                                                  <v-radio
                                                    :value="false"
                                                    label="No pasa"
                                                  ></v-radio>
                                                </v-radio-group>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <span>Presencia de coliformes</span>
                                  <v-spacer></v-spacer>
                                  <v-radio-group
                                    row
                                    v-model="loteSelected.areaThereColiforms"
                                    :disabled="
                                      loteSelected.isEndTimeValidationReady
                                    "
                                    :rules="[
                                      (v) =>
                                        loteSelected.areaThereColiforms !=
                                          undefined ||
                                        `El campo es obligatorio.`,
                                    ]"
                                  >
                                    <v-radio :value="true" label="Si"></v-radio>
                                    <v-radio
                                      :value="false"
                                      label="No"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row
                                align="center"
                                justify="end"
                                v-if="!loteSelected.isEndTimeValidationReady"
                              >
                                <v-col cols="12" xl="4" lg="4">
                                  <v-btn
                                    color="gray"
                                    dark
                                    block
                                    @click="saveTimeEndValidationRequest"
                                  >
                                    Guardar
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" xl="4" lg="4">
                                  <v-btn
                                    color="primary"
                                    dark
                                    block
                                    @click="finishTimeEndValidationRequest"
                                    >finalizar validación
                                  </v-btn>
                                </v-col>
                                <v-col
                                  cols="12"
                                  xl="4"
                                  lg="4"
                                  v-if="this.loteSelected.areaThereColiforms"
                                >
                                  <v-btn
                                    color="red"
                                    block
                                    dark
                                    @click="confirmationUseless"
                                  >
                                    Desechar lote
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="!loteSelected.isFeedable">
                  <div>
                    <v-row v-if="loteSelected.isDoneFermentation" no-gutters>
                      <v-col cols="12">
                        <span>
                          Estatus validación:
                          <div v-if="isValid != null">
                            <span v-if="isValid == true" class="primary--text">
                              Cumple
                            </span>
                            <span v-else class="red--text"> No cumple </span>
                          </div>
                          <div v-else>
                            <span>--</span>
                          </div>
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <span>Peso ideal (g): 5140.0</span>
                      </v-col>
                      <v-col cols="12">
                        <span>Peso promedio (g): {{ averageDrums }}</span>
                      </v-col>
                      <v-col cols="12">
                        <span>Diferencia con el ideal (g) {{ gapDrums }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="loteSelected.isDoneFermentation">
                      <v-col cols="12">
                        <v-btn
                          color="primary"
                          rounded
                          @click="addDrum"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                        >
                          <v-icon> mdi-plus </v-icon>
                          Agregar registro peso
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          color="gray"
                          rounded
                          @click="endDrumsRegisterRequest(false)"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                          :dark="loteSelected.isDrumsRegisterEnd ? false : true"
                        >
                          <v-icon> mdi-content-save</v-icon>
                          Guardar
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          color="warning"
                          rounded
                          @click="endDrumsRegisterRequest(true)"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                        >
                          <v-icon> mdi-receipt-text-clock-outline </v-icon>
                          Finalizar registro
                        </v-btn>
                      </v-col>
                    </v-row>
                    <div
                      class="scroll-row mt-4"
                      v-if="loteSelected.isDoneFermentation"
                    >
                      <v-form ref="formDrumsRegister" lazy-validation>
                        <v-row
                          v-for="(item, index) in loteSelected.drums"
                          :key="index"
                          class="mt-2"
                        >
                          <v-col>
                            <v-text-field
                              dense
                              outlined
                              clearable
                              :label="`Bidón ${index + 1}`"
                              v-model="item.value"
                              type="number"
                              :rules="validationNumber('campo')"
                              :disabled="loteSelected.isDrumsRegisterEnd"
                            ></v-text-field>
                          </v-col>
                          <v-col v-if="!loteSelected.isDrumsRegisterEnd">
                            <v-btn
                              color="red"
                              dark
                              small
                              @click="deleteDrum(index)"
                            >
                              <v-icon> mdi-delete </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    loteSelected.isDoneFermentation && loteSelected.isFeedable
                  "
                >
                  <v-divider inset></v-divider>
                  <div v-if="!refeed">
                    <v-row class="pt-5">
                      <v-col>
                        <span class="text-h6">
                          Realimentaciones en reactor
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-data-table
                          fixed-header
                          height="auto"
                          :headers="headersRefeed"
                          :items="refeeds"
                          no-data-text="No hay realimentaciones"
                          loading-text="Cargando realimentaciones..."
                          hide-default-footer
                        >
                          <template #[`item.serial`]="{ item }">
                            <span v-if="item.serial == 1" class="text-caption">
                              Primer inoculación
                            </span>
                            <span v-else class="text-caption">
                              Realimentación {{ item.serial - 1 }}
                            </span>
                            <span
                              v-if="item.validations.isApproved == false"
                              class="red--text"
                            >
                              (Descartado)
                            </span>
                          </template>
                          <template #[`item.inoculationDate`]="{ item }">
                            <span v-if="item.inoculationDate">
                              {{ item.inoculationDate }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template
                            #[`item.estimatedLitersInoculated`]="{ item }"
                          >
                            <span v-if="item.estimatedLitersInoculated">
                              {{ item.estimatedLitersInoculated }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.initialPh`]="{ item }">
                            <span v-if="item.initialPh">
                              {{ item.initialPh }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.adjustedPh`]="{ item }">
                            <span v-if="item.adjustedPh">
                              {{ item.adjustedPh }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.packingDate`]="{ item }">
                            <span v-if="item.packingDate">
                              {{ item.packingDate }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.litersPT`]="{ item }">
                            <span v-if="item.litersPT">
                              {{ item.litersPT }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.status`]="{ item }">
                            <span>
                              {{ getStatus(item.status) }}
                            </span>
                          </template>
                          <template #[`item.actions`]="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="setRefeed(item)"
                                  color="green"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-note-edit
                                </v-icon>
                              </template>
                              <span>Actualizar realimentación</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <v-row class="pt-5">
                      <v-col>
                        <v-btn color="primary" rounded @click="unSetRefeed">
                          <v-icon> mdi-arrow-left </v-icon>
                          Regresar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="pt-3" v-if="refeed.isDoneFirstData">
                      <v-col cols="12">
                        <span class="text-h6"> Información producción </span>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          outlined
                          dense
                          label="Fecha de inoculación"
                          clearable
                          type="date"
                          v-model="refeed.inoculationDate"
                          :disabled="refeed.isDoneFirstData"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :disabled="refeed.isDoneFirstData"
                          outlined
                          dense
                          label="Litros estimados inoculados"
                          clearable
                          type="number"
                          v-model="refeed.estimatedLitersInoculated"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :disabled="refeed.isDoneFirstData"
                          outlined
                          dense
                          label="pH Inicial"
                          clearable
                          type="number"
                          v-model="refeed.initialPh"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :disabled="refeed.isDoneFirstData"
                          outlined
                          dense
                          label="ph Ajustado"
                          clearable
                          type="number"
                          v-model="refeed.adjustedPh"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="pt-3">
                      <v-form ref="formRefeed">
                        <v-row>
                          <v-col cols="12">
                            <span class="text-h6"> Validación calidad </span>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-combobox
                              v-model="refeed.validations.staining"
                              outlined
                              clearable
                              label="Resultado tincion"
                              dense
                              :items="staining"
                              :rules="validation('Tincion')"
                              :disabled="refeed.isDoneValidations"
                            ></v-combobox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="refeed.validations.concentration"
                              type="text"
                              outlined
                              clearable
                              label="Introduce UFC/ml"
                              dense
                                :rules="validation('concentración')"
                              :disabled="refeed.isDoneValidations"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="refeed.qualityPh"
                              dense
                              outlined
                              label="Introduzca el pH"
                              type="number"
                              :rules="[(v) => !!v || 'Campo requerido']"
                              :disabled="refeed.isDoneValidations"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-row>
                              <v-col>
                                <v-card elevation="2">
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col>
                                          <span
                                            >Muestra compuesta
                                            <div
                                              v-if="
                                                refeed.validations.isApproved ==
                                                false
                                              "
                                            >
                                              <span
                                                class="text-caption red--text"
                                                >(Descartado)</span
                                              >
                                            </div>
                                          </span>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12" xl="6" lg="6" md="6">
                                          <span
                                            >Presencia de contaminación</span
                                          >
                                          <v-spacer></v-spacer>
                                          <v-radio-group
                                            v-model="
                                              refeed.validations.isContaminated
                                            "
                                            :disabled="refeed.isDoneValidations"
                                            row
                                          >
                                            <v-radio
                                              :value="true"
                                              label="Presentes"
                                            ></v-radio>
                                            <v-radio
                                              :value="false"
                                              label="Ausentes"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          xl="6"
                                          lg="6"
                                          md="6"
                                          v-if="
                                            refeed.validations.isContaminated
                                          "
                                        >
                                          <v-combobox
                                            v-model="
                                              refeed.validations
                                                .reasonForContamination
                                            "
                                            :items="contaminations"
                                            outlined
                                            dense
                                            label="Selecciona motivo de contaminación"
                                            :disabled="refeed.isDoneValidations"
                                            :rules="validation()"
                                          >
                                          </v-combobox>
                                          <v-textarea
                                            v-if="
                                              refeed.validations
                                                .reasonForContamination &&
                                              refeed.validations
                                                .reasonForContamination.value ==
                                                'OTHER'
                                            "
                                            outlined
                                            dense
                                            label="Descripción de contaminación"
                                            v-model="
                                              refeed.validations
                                                .contaminationDescription
                                            "
                                          ></v-textarea>
                                        </v-col>
                                        <v-col cols="12">
                                          <v-row>
                                            <v-col>
                                              <span>Morfologia colonial </span>
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12" sm="6">
                                              <v-select
                                                clearable
                                                v-model="
                                                  refeed.validations.morphology
                                                    .shape
                                                "
                                                :items="shape"
                                                outlined
                                                dense
                                                required
                                                label="Forma"
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                :rules="
                                                  validationConditionalF(
                                                    'forma',
                                                    refeed.validations
                                                      .isContaminated
                                                  )
                                                "
                                              ></v-select>
                                              <v-select
                                                clearable
                                                v-model="
                                                  refeed.validations.morphology
                                                    .margin
                                                "
                                                :items="margin"
                                                outlined
                                                dense
                                                required
                                                label="Borde"
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                :rules="
                                                  validationConditional(
                                                    'borde',
                                                    refeed.validations
                                                      .isContaminated
                                                  )
                                                "
                                              ></v-select>
                                              <v-select
                                                clearable
                                                v-model="
                                                  refeed.validations.morphology
                                                    .elevation
                                                "
                                                :items="elevation"
                                                outlined
                                                dense
                                                required
                                                label="Elevación"
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                :rules="
                                                  validationConditionalF(
                                                    'elevación',
                                                    refeed.validations
                                                      .isContaminated
                                                  )
                                                "
                                              ></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                              <v-select
                                                clearable
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                v-model="
                                                  refeed.validations.morphology
                                                    .surface
                                                "
                                                :items="surface"
                                                multiple
                                                outlined
                                                dense
                                                required
                                                label="Superficie"
                                                :rules="
                                                  refeed.validations
                                                    .isContaminated
                                                    ? [() => true]
                                                    : [
                                                        () =>
                                                          refeed.validations
                                                            .morphology.surface
                                                            .length > 0 ||
                                                          'La superficie requerida',
                                                      ]
                                                "
                                              >
                                                <template
                                                  v-slot:selection="{
                                                    item,
                                                    index,
                                                  }"
                                                >
                                                  <span
                                                    v-if="index === 0"
                                                    class="mr-2"
                                                    >{{ item.text }}</span
                                                  >
                                                  <span
                                                    v-if="index === 1"
                                                    class="grey--text caption"
                                                  >
                                                    ({{
                                                      refeed.validations
                                                        .morphology.surface
                                                        .length - 1
                                                    }}
                                                    más)
                                                  </span>
                                                </template>
                                              </v-select>
                                              <v-select
                                                clearable
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                v-model="
                                                  refeed.validations.morphology
                                                    .opacity
                                                "
                                                :items="opacity"
                                                outlined
                                                dense
                                                required
                                                label="Opacidad"
                                                :rules="
                                                  validationConditionalF(
                                                    'opacidad',
                                                    refeed.validations
                                                      .isContaminated
                                                  )
                                                "
                                              ></v-select>
                                              <v-select
                                                clearable
                                                :disabled="
                                                  refeed.isDoneValidations
                                                "
                                                v-model="
                                                  refeed.validations.morphology
                                                    .color
                                                "
                                                :items="color"
                                                outlined
                                                dense
                                                required
                                                label="Color"
                                                :rules="
                                                  validationConditional(
                                                    'color',
                                                    refeed.validations
                                                      .isContaminated
                                                  )
                                                "
                                              ></v-select>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col>
                                          <span>Presencia de coliformes</span>
                                          <v-spacer></v-spacer>
                                          <v-radio-group
                                            row
                                            v-model="
                                              refeed.validations
                                                .areaThereColiforms
                                            "
                                            :disabled="refeed.isDoneValidations"
                                            :rules="[
                                              (v) =>
                                                refeed.validations
                                                  .areaThereColiforms !=
                                                  undefined ||
                                                `El campo es obligatorio.`,
                                            ]"
                                          >
                                            <v-radio
                                              :value="true"
                                              label="Si"
                                            ></v-radio>
                                            <v-radio
                                              :value="false"
                                              label="No"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" xl="6" lg="6" md="6">
                                          <span class="text-body-1"
                                            >¿Esta aprobado por calidad?</span
                                          >
                                          <v-spacer></v-spacer>
                                          <v-radio-group
                                            v-model="
                                              refeed.validations.isApproved
                                            "
                                            row
                                            :disabled="refeed.isDoneValidations"
                                            :rules="[
                                              (v) =>
                                                refeed.validations.isApproved !=
                                                  undefined ||
                                                `El campo es obligatorio.`,
                                            ]"
                                          >
                                            <v-radio
                                              :value="true"
                                              label="Pasa"
                                            ></v-radio>
                                            <v-radio
                                              :value="false"
                                              label="No pasa"
                                            ></v-radio>
                                          </v-radio-group>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row
                          align="center"
                          justify="end"
                          v-if="!refeed.isDoneValidations"
                        >
                          <v-col cols="12" xl="4" lg="4">
                            <v-btn
                              color="gray"
                              dark
                              block
                              @click="saveFeedableDataRequest(false)"
                            >
                              Guardar
                            </v-btn>
                          </v-col>
                          <!-- <v-col cols="12" xl="4" lg="4">
                            <v-btn
                              color="warning"
                              dark
                              block
                              @click="showConfirmationModalDeleteReefed = true"
                            >
                              No Pasar validación
                            </v-btn>
                          </v-col> -->
                          <v-col cols="12" xl="4" lg="4">
                            <v-btn
                              color="primary"
                              dark
                              block
                              @click="showConfirmationModal = true"
                            >
                              Pasar validación
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-row>
                  </div>

                  <div v-if="loteSelected.productionState == 'STOCK_PT'">
                    <v-row
                      v-if="loteSelected.isDoneFermentation"
                      no-gutters
                      class="mt-5"
                    >
                      <v-col cols="12">
                        <span>
                          Estatus validación:
                          <div v-if="isValid != null">
                            <span v-if="isValid == true" class="primary--text">
                              Cumple
                            </span>
                            <span v-else class="red--text"> No cumple </span>
                          </div>
                          <div v-else>
                            <span>--</span>
                          </div>
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <span>Peso ideal (g): 5140.0</span>
                      </v-col>
                      <v-col cols="12">
                        <span>Peso promedio (g): {{ averageDrums }}</span>
                      </v-col>
                      <v-col cols="12">
                        <span>Diferencia con el ideal (g) {{ gapDrums }}</span>
                      </v-col>
                    </v-row>
                    <v-row v-if="loteSelected.isDoneFermentation">
                      <v-col cols="12">
                        <v-btn
                          color="primary"
                          rounded
                          @click="addDrum"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                        >
                          <v-icon> mdi-plus </v-icon>
                          Agregar registro peso
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          color="gray"
                          rounded
                          @click="endDrumsRegisterRequest(false)"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                          :dark="loteSelected.isDrumsRegisterEnd ? false : true"
                        >
                          <v-icon> mdi-content-save</v-icon>
                          Guardar
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          color="warning"
                          rounded
                          @click="endDrumsRegisterRequest(true)"
                          :disabled="loteSelected.isDrumsRegisterEnd"
                        >
                          <v-icon> mdi-receipt-text-clock-outline </v-icon>
                          Finalizar registro
                        </v-btn>
                      </v-col>
                    </v-row>
                    <div
                      class="scroll-row mt-4"
                      v-if="loteSelected.isDoneFermentation"
                    >
                      <v-form ref="formDrumsRegister" lazy-validation>
                        <v-row
                          v-for="(item, index) in loteSelected.drums"
                          :key="index"
                          class="mt-2"
                        >
                          <v-col>
                            <v-text-field
                              dense
                              outlined
                              clearable
                              :label="`Bidón ${index + 1}`"
                              v-model="item.value"
                              type="number"
                              :rules="validationNumber('campo')"
                              :disabled="loteSelected.isDrumsRegisterEnd"
                            ></v-text-field>
                          </v-col>
                          <v-col v-if="!loteSelected.isDrumsRegisterEnd">
                            <v-btn
                              color="red"
                              dark
                              small
                              @click="deleteDrum(index)"
                            >
                              <v-icon> mdi-delete </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>
                  </div>
                </div>
              </v-container>
              <v-container
                v-if="
                  loteSelected.productionType &&
                  loteSelected.productionType.value == 'mr'
                "
              >
                <v-row>
                  <v-col v-if="loteSelected.isDoneMRFirstStep">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso de producción finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En espera de producción...</span>
                  </v-col>
                </v-row>
                <v-row
                  class="text-end py-2"
                  v-if="!!loteSelected.endSeedValidations"
                >
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="loteSelected.isDoneMRFirstStepValidations"
                      @click="showConfirmattionUndoSeed = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Deshacer Semilla
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="loteSelected.isDoneMRFirstStep">
                  <v-col>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          validaciones
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-form ref="formMRValidations" lazy-validation>
                            <div>
                              <v-tabs
                                v-model="currentMiniReactorTab"
                                show-arrows
                              >
                                <v-tab
                                  v-for="(
                                    flask, index
                                  ) in loteSelected.miniReactorFlasks"
                                  :key="index"
                                >
                                  {{ flask.name }}
                                  <v-icon
                                    v-if="flask.isApproved == false"
                                    small
                                    color="error"
                                    class="ml-1"
                                  >
                                    mdi-alert
                                  </v-icon>
                                </v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="currentMiniReactorTab">
                                <v-tab-item
                                  v-for="(
                                    flask, index
                                  ) in loteSelected.miniReactorFlasks"
                                  :key="index"
                                >
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <v-combobox
                                          v-model="flask.staining"
                                          outlined
                                          clearable
                                          label="Resultado tincion"
                                          dense
                                          :items="staining"
                                          :rules="validation('Tincion')"
                                          :disabled="
                                            loteSelected.isDoneMRFirstStepValidations
                                          "
                                        ></v-combobox>
                                      </v-col>

                                      <v-col cols="12" md="6">
                                        <v-text-field
                                          v-model="flask.concentration"
                                          type="text"
                                          outlined
                                          clearable
                                          label="Introduce UFC/ml"
                                          dense
                                          :rules="validation('concentración')"
                                          :disabled="
                                            loteSelected.isDoneMRFirstStepValidations
                                          "
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-text-field
                                          dense
                                          outlined
                                          label="Introduzca el pH"
                                          type="text"
                                          :rules="[
                                            (v) => !!v || 'medida obligatoria',
                                          ]"
                                          v-model="flask.qualityPh"
                                          :disabled="
                                            loteSelected.isDoneMRFirstStepValidations
                                          "
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-row>
                                          <v-col>
                                            <v-card elevation="2">
                                              <v-card-text>
                                                <v-container>
                                                  <v-row>
                                                    <v-col>
                                                      <span
                                                        >{{ flask.name }}
                                                        <div
                                                          v-if="
                                                            flask.isApproved ==
                                                            false
                                                          "
                                                        >
                                                          <span
                                                            class="text-caption red--text"
                                                            >(Descartado)</span
                                                          >
                                                        </div>
                                                      </span>
                                                    </v-col>
                                                  </v-row>

                                                  <v-row>
                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                    >
                                                      <span
                                                        >Presencia de
                                                        contaminación</span
                                                      >
                                                      <v-spacer></v-spacer>
                                                      <v-radio-group
                                                        v-model="
                                                          flask.isContaminated
                                                        "
                                                        row
                                                        :disabled="
                                                          loteSelected.isDoneMRFirstStepValidations
                                                        "
                                                      >
                                                        <v-radio
                                                          :value="true"
                                                          label="Presentes"
                                                        ></v-radio>
                                                        <v-radio
                                                          :value="false"
                                                          label="Ausentes"
                                                        ></v-radio>
                                                      </v-radio-group>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      xl="6"
                                                      lg="6"
                                                      md="6"
                                                      v-if="
                                                        flask.isContaminated
                                                      "
                                                    >
                                                      <v-combobox
                                                        v-model="
                                                          flask.reasonForContamination
                                                        "
                                                        :items="contaminations"
                                                        outlined
                                                        dense
                                                        label="Selecciona motivo de contaminación"
                                                        :disabled="
                                                          loteSelected.isDoneMRFirstStepValidations
                                                        "
                                                        :rules="validation()"
                                                      ></v-combobox>
                                                      <v-textarea
                                                        v-if="
                                                          flask.reasonForContamination &&
                                                          flask
                                                            .reasonForContamination
                                                            .value == 'OTHER'
                                                        "
                                                        :disabled="
                                                          loteSelected.isDoneMRFirstStepValidations
                                                        "
                                                        outlined
                                                        dense
                                                        label="Descripción de contaminación"
                                                        v-model="
                                                          flask.contaminationDescription
                                                        "
                                                      ></v-textarea>
                                                    </v-col>

                                                    <v-col cols="12">
                                                      <v-row>
                                                        <v-col>
                                                          <span
                                                            >Morfologia
                                                            colonial</span
                                                          >
                                                        </v-col>
                                                      </v-row>

                                                      <v-row>
                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .shape
                                                            "
                                                            :items="shape"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Forma"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'forma',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .margin
                                                            "
                                                            :items="margin"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Borde"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'borde',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .elevation
                                                            "
                                                            :items="elevation"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Elevación"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'elevación',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .surface
                                                            "
                                                            :rules="
                                                              flask.isContaminated
                                                                ? [() => true]
                                                                : [
                                                                    () =>
                                                                      flask
                                                                        .morphology
                                                                        .surface
                                                                        .length >
                                                                        0 ||
                                                                      'La superficie requerida',
                                                                  ]
                                                            "
                                                            :items="surface"
                                                            multiple
                                                            outlined
                                                            dense
                                                            required
                                                            label="Superficie"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                          >
                                                            <template
                                                              v-slot:selection="{
                                                                item,
                                                                index,
                                                              }"
                                                            >
                                                              <span
                                                                v-if="
                                                                  index === 0
                                                                "
                                                                class="mr-2"
                                                                >{{
                                                                  item.text
                                                                }}</span
                                                              >
                                                              <span
                                                                v-if="
                                                                  index === 1
                                                                "
                                                                class="grey--text caption"
                                                              >
                                                                ({{
                                                                  flask
                                                                    .morphology
                                                                    .surface
                                                                    .length - 1
                                                                }}
                                                                más)
                                                              </span>
                                                            </template>
                                                          </v-select>

                                                          <v-select
                                                            clearable
                                                            v-model="
                                                              flask.morphology
                                                                .opacity
                                                            "
                                                            :items="opacity"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Opacidad"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                            :rules="
                                                              validationConditionalF(
                                                                'opacidad',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>

                                                          <v-select
                                                            v-model="
                                                              flask.morphology
                                                                .color
                                                            "
                                                            :items="color"
                                                            outlined
                                                            dense
                                                            required
                                                            label="Color"
                                                            :disabled="
                                                              loteSelected.isDoneMRFirstStepValidations
                                                            "
                                                            :rules="
                                                              validationConditional(
                                                                'color',
                                                                flask.isContaminated
                                                              )
                                                            "
                                                          ></v-select>
                                                        </v-col>
                                                      </v-row>
                                                    </v-col>
                                                  </v-row>
                                                </v-container>
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-col>

                                      <v-col cols="12">
                                        <v-textarea
                                          v-model="flask.observations"
                                          outlined
                                          name="input-7-4"
                                          label="Observaciones"
                                          dense
                                          :disabled="
                                            loteSelected.isDoneMRFirstStepValidations
                                          "
                                        ></v-textarea>
                                      </v-col>
                                      <v-col cols="12" xl="6" lg="6" md="6">
                                        <span class="text-body-1"
                                          >¿Esta aprobado por calidad?</span
                                        >
                                        <v-spacer></v-spacer>
                                        <v-radio-group
                                          v-model="flask.isApproved"
                                          row
                                          :disabled="
                                            loteSelected.isDoneMRFirstStepValidations
                                          "
                                          :rules="[
                                            (v) =>
                                              flask.isApproved != undefined ||
                                              `El campo es obligatorio.`,
                                          ]"
                                        >
                                          <v-radio
                                            :value="true"
                                            label="Pasa"
                                          ></v-radio>
                                          <v-radio
                                            :value="false"
                                            label="No pasa"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                      <v-col cols="12">
                                        <v-row>
                                          <v-col>
                                            <span>Presencia de coliformes</span>
                                            <v-spacer></v-spacer>
                                            <v-radio-group
                                              row
                                              v-model="flask.areaThereColiforms"
                                              :disabled="
                                                loteSelected.isDoneMRFirstStepValidations
                                              "
                                              :rules="[
                                                (v) =>
                                                  v !== undefined ||
                                                  'El campo es obligatorio.',
                                              ]"
                                            >
                                              <v-radio
                                                :value="true"
                                                label="Si"
                                              ></v-radio>
                                              <v-radio
                                                :value="false"
                                                label="No"
                                              ></v-radio>
                                            </v-radio-group>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-tab-item>
                              </v-tabs-items>
                            </div>
                            <v-row
                              justify="end"
                              v-if="showAdviceMiniReactorValidations"
                            >
                              <v-col align="end">
                                <span class="red--text"
                                  >* {{ messageAdviceMiniReactorValidations }}
                                </span>
                              </v-col>
                            </v-row>

                            <v-row
                              align="center"
                              justify="end"
                              v-if="!loteSelected.isDoneMRFirstStepValidations"
                            >
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="gray"
                                  dark
                                  block
                                  @click="mrValidations(false)"
                                >
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col cols="12" xl="4" lg="4">
                                <v-btn
                                  color="primary"
                                  dark
                                  block
                                  @click="mrValidations(true)"
                                  >Validar
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
          </v-stepper>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <GenericConfirmationModalDeleteLote
      v-model="showGenericConfirmationModalDeleteLote"
      @confirmation="confirmDeleteLote"
      :title="'¿Estás seguro que quieres elimnar lote por contaminación?'"
    />
    <ConfirmationModal
      v-model="showConfirmationModal"
      @confirmation="saveFeedableDataRequest(true)"
      :title="'¿Estás seguro que quieres finalizar validacion?'"
    />
    <ConfirmationModalDeleteReefed
      v-model="showConfirmationModalDeleteReefed"
      @confirmation="saveFeedableDataRequest(true, true)"
      :title="'¿Estás seguro que quieres descartar esta realimentación?'"
    />
    <DiscardLoteModal
      v-model="showDiscardLoteModal"
      @confirmation="dicardLote"
    />
    <ConfirmattionUndoSeed
      v-model="showConfirmattionUndoSeed"
      @confirmation="handleUndoSeed()"
      :title="'¿Estás seguro que quieres regresar a semilla?'"
    />
    <ConfirmattionUndoFinishInoculate
      v-model="showConfirmattionUndoFinishInoculate"
      @confirmation="handleUndoInoculate()"
      :title="'¿Estás seguro que quieres regresar a Inóculo?'"
    />

    <ConfirmattionUndoFinishPreinoculate
      v-model="showConfirmattionUndoFinishPreinoculate"
      @confirmation="handleUndoFinishPreinoculate()"
      :title="'¿Estás seguro que quieres regresar a Preinóculo?'"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//components
import Modal from "@/components/utils/GenericConfirmationModal.vue";
import GenericConfirmationModalDeleteLote from "@/components/dashboard/lote/modals/DeleteLoteModal.vue";
import ConfirmationModal from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationModalDeleteReefed from "@/components/utils/GenericConfirmationModal.vue";
import DiscardLoteModal from "@/components/dashboard/lote/modals/DiscardLoteModal.vue";
import ConfirmattionUndoSeed from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmattionUndoFinishInoculate from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmattionUndoFinishPreinoculate from "@/components/utils/GenericConfirmationModal.vue";

//validations d
import {
  requiredFValidation,
  requiredValidation,
  requiredMultiple,
  numberValidation,
} from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
export default {
  components: {
    Modal,
    GenericConfirmationModalDeleteLote,
    DiscardLoteModal,
    ConfirmationModal,
    ConfirmationModalDeleteReefed,
    ConfirmattionUndoSeed,
    ConfirmattionUndoFinishInoculate,
    ConfirmattionUndoFinishPreinoculate,
  },
  data: () => ({
    showConfirmattionUndoFinishPreinoculate: false,
    showConfirmattionUndoFinishInoculate: false,
    showConfirmattionUndoSeed: false,
    showGenericConfirmationModalDeleteLote: false,
    showMFAdviceInoculate: false,
    messageMFAdviceInoculate: "",
    showAdviceMFPreinoculate: false,
    messageAdviceMFPreinoculate: "",
    showAdviceMFSeed: false,
    messageAdviceMFSeed: "",
    showDiscardLoteModal: false,
    user: JSON.parse(localStorage.getItem("user")),
    stepper: 1,
    contaminations: [
      { text: "Bacillus licheniformis", value: "Bacillus licheniformis" },
      {
        text: "Bacillus paralicheniformis",
        value: "Bacillus paralicheniformis",
      },
      { text: "Bacillus sp.", value: "Bacillus sp." },
      { text: "Pseudomonas sp.", value: "Pseudomonas sp." },
      { text: "cocos", value: "cocos" },
      { text: "Trichoderma sp.", value: "Trichoderma sp." },
      { text: "Paecilomyces lilacinus", value: "Paecilomyces lilacinus" },
      { text: "Otro", value: "OTHER" },
    ],
    validationEndTime: null,
    headers: [
      {
        text: "Realimentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Envasado",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "UFC/mL",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Validación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
    ],
    staining: [
      { text: "Gram +", value: "positve" },
      { text: "Gram -", value: "negative" },
      { text: "No se realizo", value: "undefined" },
    ],
    productionTypes: [
      { text: "Bidón", value: "drum" },
      { text: "Reactor", value: "reactor" },
    ],
    headersRefeed: [
      {
        text: "Tipo",
        align: "center",
        value: "serial",
        sortable: false,
      },
      {
        text: "Fecha de inoculación",
        align: "center",
        value: "inoculationDate",
        sortable: false,
      },
      {
        text: "Litros estimados inoculados",
        align: "center",
        value: "estimatedLitersInoculated",
        sortable: false,
      },
      {
        text: "pH inicial",
        align: "center",
        value: "initialPh",
        sortable: false,
      },
      {
        text: "pH ajustado",
        align: "center",
        value: "adjustedPh",
        sortable: false,
      },
      {
        text: "Fecha de envasado",
        align: "center",
        value: "packingDate",
        sortable: false,
      },
      {
        text: "Litros envasados",
        align: "center",
        value: "litersPT",
        sortable: false,
      },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Acciones",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
    refeeds: [],
    refeed: null,
    averageDrums: 0,
    gapDrums: 0,
    isValid: null,
    showAdviceMiniReactorValidations: false,
    messageAdviceMiniReactorValidations: null,
    showConfirmationModal: false,
    showConfirmationModalDeleteReefed: false,
    currentJarTab: 0,
    currentFlaskTab: 0,
    currentSeedJarTab: 0,
    currentMiniReactorTab: 0,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("lotes", ["loteSelected"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    // set morphology
    await this.fillMorphology();
    //validate step to go to correct step
    if (this.loteSelected.productionState == "PREINOCULATE") {
      this.stepper = 1;
    } else if (this.loteSelected.productionState == "INOCULATE") {
      this.stepper = 2;
    } else if (this.loteSelected.productionState == "SEED") {
      this.stepper = 3;
    } else if (this.loteSelected.productionState == "FERMENTATION") {
      this.stepper = 4;
    } else {
      this.stepper = 4;
    }
    this.setRefeeds();
  },
  methods: {
    getFieldRef(fieldName) {
      return `fieldRef_${fieldName}`;
    },
    ...mapActions("lotes", [
      "saveDataPreinoculateValidation",
      "finishPreinoculate",
      "saveInoculate",
      "finishInoculate",
      "saveSeed",
      "endSeed",
      "saveTimeEndValidation",
      "finishTimeEndValidation",
      "makeUselessLote",
      "saveFeedableData",
      "endDrumsRegister",
      "deleteLote",
      "discardLote",
      "saveReactorFermentationSterilizationQuality",
      "saveMRValidation",
      "undoEndSeed",
      "undoFinishInoculate",
      "undoFinishPreinoculate",
    ]),
    ...mapActions("bioactives", ["getMorphology"]),
    ...mapMutations("lotes", ["SET_LOTE_SELECTED", "SET_FETCH_LOTES_LIST"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    validationNumber(name) {
      return numberValidation({ min: 1, name: name, required: true });
    },
    validationNumberMin(name, min) {
      return numberValidation({ min: 0, name: name, required: true });
    },
    validationConditional(name, flag) {
      if (flag) {
        return [() => true];
      } else {
        return requiredValidation(name);
      }
    },
    validationConditionalF(name, flag) {
      if (flag) {
        return [() => true];
      } else {
        return requiredFValidation(name);
      }
    },

    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    setRefeeds() {
      if (this.loteSelected && this.loteSelected.refeedables) {
        this.refeeds = this.loteSelected.refeedables;
      }
    },
    getStatus(status) {
      if (status == "NOT_STARTED") {
        return "Sin iniciar";
      } else if (status == "IN_PROGRESS") {
        return "En proceso";
      } else if (status == "VALIDATED") {
        return "Validado por calidad";
      } else if (status == "FINISHED") {
        return "Producto terminado";
      }
    },
    async getBaseMorphology() {
      let baseMorphology = {};
      let response = await this.getMorphology({
        identification: this.loteSelected.identification,
      });
      if (response) {
        baseMorphology = response.mophologyFound;
        if (!baseMorphology) {
          baseMorphology = {
            obverse: "",
            reverse: "",
            texture: "",
            growth: "",
            surface: [],
            shape: "",
            margin: "",
            elevation: "",
            color: "",
            opacity: "",
            gram: false,
            KOH: false,
            catalase: false,
            oxidase: false,
          };
        }
      }
      return baseMorphology;
    },
    async fillMorphology() {
      let baseMorphology = await this.getBaseMorphology();

      if (this.loteSelected.flasks) {
        for (const item of this.loteSelected.flasks) {
          if (
            (!item.morphology.margin || item.morphology.margin.length == 0) &&
            (!item.morphology.elevation ||
              item.morphology.elevation.length == 0) &&
            (!item.morphology.surface || item.morphology.surface.length == 0) &&
            (!item.morphology.opacity || item.morphology.opacity.length == 0) &&
            (!item.morphology.color || item.morphology.color.length == 0)
          ) {
            item.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        }
      }

      if (this.loteSelected.jars) {
        for (const item of this.loteSelected.jars) {
          if (
            (!item.morphology.margin || item.morphology.margin.length == 0) &&
            (!item.morphology.elevation ||
              item.morphology.elevation.length == 0) &&
            (!item.morphology.surface || item.morphology.surface.length == 0) &&
            (!item.morphology.opacity || item.morphology.opacity.length == 0) &&
            (!item.morphology.color || item.morphology.color.length == 0)
          ) {
            item.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        }
      }

      if (this.loteSelected.jarsSeed) {
        for (const item of this.loteSelected.jarsSeed) {
          if (
            (!item.morphology.margin || item.morphology.margin.length == 0) &&
            (!item.morphology.elevation ||
              item.morphology.elevation.length == 0) &&
            (!item.morphology.surface || item.morphology.surface.length == 0) &&
            (!item.morphology.opacity || item.morphology.opacity.length == 0) &&
            (!item.morphology.color || item.morphology.color.length == 0)
          ) {
            item.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        }
      }
      if (this.loteSelected.jarsSeedFeedable) {
        for (const item of this.loteSelected.jarsSeedFeedable) {
          if (
            (!item.morphology.margin || item.morphology.margin.length == 0) &&
            (!item.morphology.elevation ||
              item.morphology.elevation.length == 0) &&
            (!item.morphology.surface || item.morphology.surface.length == 0) &&
            (!item.morphology.opacity || item.morphology.opacity.length == 0) &&
            (!item.morphology.color || item.morphology.color.length == 0)
          ) {
            item.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        }
      }

      if (!this.loteSelected.validationEndTime) {
        this.validationEndTime = {
          isContaminated: false,
          morphology: {
            obverse: "",
            reverse: "",
            texture: "",
            growth: "",
            surface: [],
            shape: "",
            margin: "",
            elevation: "",
            color: "",
            opacity: "",
            gram: false,
            KOH: false,
            catalase: false,
            oxidase: false,
          },
          staining: null,
          concentration: null,
          reasonForContamination: "",
        };
        this.validationEndTime.morphology = JSON.parse(
          JSON.stringify(baseMorphology)
        );
      } else {
        this.validationEndTime = this.loteSelected.validationEndTime;
      }
      if (this.refeed) {
        if (
          (!this.refeed.validations.morphology.margin ||
            this.refeed.validations.morphology.margin.length == 0) &&
          (!this.refeed.validations.morphology.elevation ||
            this.refeed.validations.morphology.elevation.length == 0) &&
          (!this.refeed.validations.morphology.surface ||
            this.refeed.validations.morphology.surface.length == 0) &&
          (!this.refeed.validations.morphology.opacity ||
            this.refeed.validations.morphology.opacity.length == 0) &&
          (!this.refeed.validations.morphology.color ||
            this.refeed.validations.morphology.color.length == 0)
        ) {
          this.refeed.validations.morphology = JSON.parse(
            JSON.stringify(baseMorphology)
          );
        }
      }
      if (this.loteSelected.miniReactorFlasks) {
        for (const item of this.loteSelected.miniReactorFlasks) {
          if (
            (!item.morphology.margin || item.morphology.margin.length == 0) &&
            (!item.morphology.elevation ||
              item.morphology.elevation.length == 0) &&
            (!item.morphology.surface || item.morphology.surface.length == 0) &&
            (!item.morphology.opacity || item.morphology.opacity.length == 0) &&
            (!item.morphology.color || item.morphology.color.length == 0)
          ) {
            item.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        }
      }
    },
    async saveDataPreinoculateValidationRequest() {
      if (this.loteSelected.flasks.length == 0) {
        this.showAdviceMFPreinoculate = true;
        this.messageAdviceMFPreinoculate = "Aún no hay matraces que validar";
        return;
      }

      if (this.$refs.formPreinoculateValidation.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            flasks: this.loteSelected.flasks,
          };
          let response = await this.saveDataPreinoculateValidation(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async finishPreinoculateRequest() {
      if (this.loteSelected.flasks.length == 0) {
        this.showAdviceMFPreinoculate = true;
        this.messageAdviceMFPreinoculate = "Aún no hay matraces que validar";
        return;
      }

      let isValid = true;

      isValid = this.$refs.formPreinoculateValidation.validate();

      if (isValid) {
        for (let item of this.loteSelected.flasks) {
          if (!item.staining) {
            this.showAdviceMFPreinoculate = true;
            this.messageAdviceMFPreinoculate =
              "Llena el formulario de todos los matraces de manera correcta";
            isValid = false;
            break;
          }
          if (!item.concentration) {
            isValid = false;
            this.showAdviceMFPreinoculate = true;
            break;
          } 
          // else if (parseInt(item.concentration) < 0) {
          //   isValid = false;
          //   this.showAdviceMFPreinoculate = true;
          //   this.messageAdviceMFPreinoculate =
          //     "Llena el formulario de todos los matraces de manera correcta";
          //   break;
          // }
          if (item.isApproved == undefined) {
            this.showAdviceMFPreinoculate = true;
            this.messageAdviceMFPreinoculate =
              "Llena el formulario de todos los matraces de manera correcta";
            isValid = false;
            break;
          }
        }
      } else {
        this.showAdviceMFPreinoculate = true;
        this.messageAdviceMFPreinoculate =
          "Llena el formulario de todos los matraces de manera correcta";
      }

      if (isValid) {
        for (let item of this.loteSelected.flasks) {
          if (
            !item.morphology.margin ||
            item.morphology.margin.length == 0 ||
            !item.morphology.elevation ||
            item.morphology.elevation.length == 0 ||
            !item.morphology.surface ||
            item.morphology.surface.length == 0 ||
            !item.morphology.opacity ||
            item.morphology.opacity.length == 0 ||
            !item.morphology.color ||
            item.morphology.color.length == 0
          ) {
            isValid = false;
            this.showAdviceMFPreinoculate = true;
            this.messageAdviceMFPreinoculate =
              "Llena el formulario de todos los matraces de manera correcta";
            break;
          }
        }
      }

      if (isValid) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            flasks: this.loteSelected.flasks,
          };
          let response = await this.finishPreinoculate(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (response.lote.dosesStart <= 2) {
              this.stepper = 4;
            } else {
              this.stepper = 2;
            }
            let baseMorphology = await this.getBaseMorphology();
            for (const item of this.loteSelected.jars) {
              if (
                (!item.morphology.margin ||
                  item.morphology.margin.length == 0) &&
                (!item.morphology.elevation ||
                  item.morphology.elevation.length == 0) &&
                (!item.morphology.surface ||
                  item.morphology.surface.length == 0) &&
                (!item.morphology.opacity ||
                  item.morphology.opacity.length == 0) &&
                (!item.morphology.color || item.morphology.color.length == 0)
              ) {
                item.morphology = JSON.parse(JSON.stringify(baseMorphology));
              }
            }
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Preinóculo finalizado!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar preinóculo`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al finalizar preinóculo`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async saveInoculateRequest() {
      if (this.loteSelected.jars.length == 0) {
        this.showMFAdviceInoculate = true;
        this.messageMFAdviceInoculate = "Aún no hay frascos que validar";
        return;
      }
      // if (this.$refs.formInoculateValidation.validate()) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          jars: this.loteSelected.jars,
        };
        let response = await this.saveInoculate(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      // }
    },
    async finishInoculateRequest() {
      if (this.loteSelected.jars.length == 0) {
        this.showMFAdviceInoculate = true;
        this.messageMFAdviceInoculate = "Aún no hay frascos que validar";
        return;
      }

      let isValid = true;

      isValid = this.$refs.formInoculateValidation.validate();
      if (isValid) {
        for (let item of this.loteSelected.jars) {
          if (!item.staining) {
            this.messageMFAdviceInoculate =
              "Llena el formulario de todos los frascos de manera correcta";
            this.showMFAdviceInoculate = true;
            isValid = false;
          }
          if (!item.concentration) {
            isValid = false;
            this.messageMFAdviceInoculate =
              "Llena el formulario de todos los frascos de manera correcta";
            this.showMFAdviceInoculate = true;
          } 
          // else if (parseInt(item.concentration) < 0) {
          //   isValid = false;
          //   this.messageMFAdviceInoculate =
          //     "Llena el formulario de todos los frascos de manera correcta";
          //   this.showMFAdviceInoculate = true;
          // }
          if (item.isApproved == undefined) {
            this.messageMFAdviceInoculate =
              "Llena el formulario de todos los frascos de manera correcta";
            this.showMFAdviceInoculate = true;
            isValid = false;
          }
        }
      } else {
        this.messageMFAdviceInoculate =
          "Llena el formulario de todos los frascos de manera correcta";
        this.showMFAdviceInoculate = true;
      }

      if (isValid) {
        for (let item of this.loteSelected.jars) {
          if (
            !item.morphology.margin ||
            item.morphology.margin.length == 0 ||
            !item.morphology.elevation ||
            item.morphology.elevation.length == 0 ||
            !item.morphology.surface ||
            item.morphology.surface.length == 0 ||
            !item.morphology.opacity ||
            item.morphology.opacity.length == 0 ||
            !item.morphology.color ||
            item.morphology.color.length == 0
          ) {
            isValid = false;
            this.messageMFAdviceInoculate =
              "Llena el formulario de todos los frascos de manera correcta";
            this.showMFAdviceInoculate = true;
            break;
          }
        }
      }
      if (isValid) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            jars: this.loteSelected.jars,
          };
          let response = await this.finishInoculate(payload);
          if (response) {
            this.stepper = 3;

            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            let baseMorphology = await this.getBaseMorphology();
            for (const item of this.loteSelected.jarsSeed) {
              if (
                (!item.morphology.margin ||
                  item.morphology.margin.length == 0) &&
                (!item.morphology.elevation ||
                  item.morphology.elevation.length == 0) &&
                (!item.morphology.surface ||
                  item.morphology.surface.length == 0) &&
                (!item.morphology.opacity ||
                  item.morphology.opacity.length == 0) &&
                (!item.morphology.color || item.morphology.color.length == 0)
              ) {
                item.morphology = JSON.parse(JSON.stringify(baseMorphology));
              }
            }
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Semilla iniciada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al iniciar semilla`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al iniciar semilla`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async saveSeedRequest() {
      if (this.loteSelected.jarsSeed.length == 0) {
        this.showAdviceMFSeed = true;
        this.messageAdviceMFSeed = "Aún no hay frascos que validar";
        return;
      }
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          jarsSeed: this.loteSelected.jarsSeed,
        };
        let response = await this.saveSeed(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async endSeedRequest() {
      if (this.loteSelected.jarsSeed.length == 0) {
        this.showAdviceMFSeed = true;
        this.messageAdviceMFSeed = "Aún no hay frascos que validar";
        return;
      }
      let isValid = true;

      isValid = this.$refs.formSeedValidations.validate();

      if (isValid) {
        for (let item of this.loteSelected.jarsSeed) {
          if (!item.staining) {
            this.showAdviceMFSeed = true;
            this.messageAdviceMFSeed =
              "Llena el formulario de todos los frascos de manera correcta";
            isValid = false;
          }
          if (!item.concentration) {
            isValid = false;
            this.messageAdviceMFSeed =
              "Llena el formulario de todos los frascos de manera correcta";
            this.showAdviceMFSeed = true;
          } 
          // else if (parseInt(item.concentration) < 0) {
          //   isValid = false;
          //   this.messageAdviceMFSeed =
          //     "Llena el formulario de todos los frascos de manera correcta";
          //   this.showAdviceMFSeed = true;
          // }
          if (item.isApproved == undefined) {
            this.showAdviceMFSeed = true;
            this.messageAdviceMFSeed =
              "Llena el formulario de todos los frascos de manera correcta";
            isValid = false;
          }
        }
      } else {
        this.messageAdviceMFSeed =
          "Llena el formulario de todos los frascos de manera correcta";
        this.showAdviceMFSeed = true;
      }

      if (isValid) {
        for (let item of this.loteSelected.jarsSeed) {
          if (
            !item.morphology.margin ||
            item.morphology.margin.length == 0 ||
            !item.morphology.elevation ||
            item.morphology.elevation.length == 0 ||
            !item.morphology.surface ||
            item.morphology.surface.length == 0 ||
            !item.morphology.opacity ||
            item.morphology.opacity.length == 0 ||
            !item.morphology.color ||
            item.morphology.color.length == 0
          ) {
            isValid = false;
            this.showAdviceMFSeed = true;
            this.messageAdviceMFSeed =
              "Llena el formulario de todos los frascos de manera correcta";
            break;
          }
        }
      }

      if (isValid) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            jarsSeed: this.loteSelected.jarsSeed,
          };
          let response = await this.endSeed(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Semilla finalizada!!",
              timeout: 3500,
            });
            let baseMorphology = await this.getBaseMorphology();
            if (this.loteSelected.miniReactorFlasks) {
              for (const item of this.loteSelected.miniReactorFlasks) {
                if (
                  (!item.morphology.margin ||
                    item.morphology.margin.length == 0) &&
                  (!item.morphology.elevation ||
                    item.morphology.elevation.length == 0) &&
                  (!item.morphology.surface ||
                    item.morphology.surface.length == 0) &&
                  (!item.morphology.opacity ||
                    item.morphology.opacity.length == 0) &&
                  (!item.morphology.color || item.morphology.color.length == 0)
                ) {
                  item.morphology = JSON.parse(JSON.stringify(baseMorphology));
                }
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar semilla`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al finalizar semilla`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async saveTimeEndValidationRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          stainingEndTime: this.loteSelected.stainingEndTime,
          ufcEndTime: this.loteSelected.ufcEndTime,
          validationEndTime: this.validationEndTime,
          areaThereColiforms: this.loteSelected.areaThereColiforms,
        };
        let response = await this.saveTimeEndValidation(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async finishTimeEndValidationRequest() {
      if (this.$refs.formValidationEndTime.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            stainingEndTime: this.loteSelected.stainingEndTime,
            ufcEndTime: this.loteSelected.ufcEndTime,
            validationEndTime: this.validationEndTime,
            areaThereColiforms: this.loteSelected.areaThereColiforms,
          };
          let response = await this.finishTimeEndValidation(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            // await this.fillMorphology();
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Validación finalizada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar validación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al finalizar validación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async setRefeed(item) {
      this.refeed = item;
      let baseMorphology = await this.getBaseMorphology();
      if (
        (!this.refeed.validations.morphology.margin ||
          this.refeed.validations.morphology.margin.length == 0) &&
        (!this.refeed.validations.morphology.elevation ||
          this.refeed.validations.morphology.elevation.length == 0) &&
        (!this.refeed.validations.morphology.surface ||
          this.refeed.validations.morphology.surface.length == 0) &&
        (!this.refeed.validations.morphology.opacity ||
          this.refeed.validations.morphology.opacity.length == 0) &&
        (!this.refeed.validations.morphology.color ||
          this.refeed.validations.morphology.color.length == 0)
      ) {
        this.refeed.validations.morphology = JSON.parse(
          JSON.stringify(baseMorphology)
        );
      }
    },
    unSetRefeed() {
      this.refeed = null;
    },
    async confirmationUseless() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
        };

        let response = await this.makeUselessLote(payload);

        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.show = false;
          this.$swal({
            icon: "success",
            title: `Se ha desechado el lote exitosamente!!`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al desechar el lote`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al desechar el lote`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async dicardLote(reasonForRejection) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          reasonContamination: reasonForRejection,
        };
        let response = await this.discardLote(payload);
        if (!response) throw response;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.$swal({
          icon: "success",
          title: `Se ha desechado el lote exitosamente`,
          showConfirmButton: false,
          timer: 2000,
        });
        this.show = false;
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al desechar el lote`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveFeedableDataRequest(isDone) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          refeed: this.refeed,
          isDoneValidations: isDone,
          role: "QUALITY",
        };
        if (isDone ? this.$refs.formRefeed.validate() : true) {
          let response = await this.saveFeedableData(payload);
          if (response) {
            this.refeed = response.refeed;
            this.refeeds = response.lote.refeedables;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    addDrum() {
      this.loteSelected.drums.push({
        value: null,
      });
    },
    deleteDrum(index) {
      this.loteSelected.drums.splice(index, 1);
    },
    async endDrumsRegisterRequest(isDone) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          drums: this.loteSelected.drums,
          isDone: isDone,
        };
        let validation = true;
        if (isDone) {
          validation = this.$refs.formDrumsRegister.validate();
        }
        if (validation) {
          let response = await this.endDrumsRegister(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (isDone) {
              this.$swal({
                icon: "success",
                title: `Registro finalizado!!`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.show = false;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Información guardada!!!",
                timeout: 3500,
              });
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar registro`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar registro`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async confirmDeleteLote(obj) {
      if (obj) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            reasonContamination: obj.value,
            user: this.user._id,
          };
          let response = await this.deleteLote(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.$swal({
              icon: "success",
              title: "Se descarto lote exitosamente!!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.show = false;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al descartar lote por contaminación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al descartar lote por contaminación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async endReactorFermentationSterilizationQuality() {
      if (this.$refs.formReactorFermentationSterilizationQuality.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            observations:
              this.loteSelected
                .reactorFermentationSterilizationQualityObservations,
            isValid: this.loteSelected.reactorFermentationSterilizationQuality,
          };
          let response = await this.saveReactorFermentationSterilizationQuality(
            payload
          );
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal. Error: ${error.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async mrValidations(flag) {
      this.showAdviceMiniReactorValidations = false;
      this.messageAdviceMiniReactorValidations = "";
      let isValid = true;
      if (flag) {
        isValid = this.$refs.formMRValidations.validate();

        if (this.loteSelected.miniReactorFlasks.length == 0) {
          this.showAdviceMiniReactorValidations = true;
          this.messageAdviceMiniReactorValidations =
            "Aún no hay matraces que validar";
          return;
        }

        if (isValid) {
          for (let item of this.loteSelected.miniReactorFlasks) {
            if (!item.staining) {
              this.showAdviceMiniReactorValidations = true;
              this.messageAdviceMiniReactorValidations =
                "Llena el formulario de todos los frascos de manera correcta";
              isValid = false;
              break;
            }
            if (!item.qualityPh) {
              this.showAdviceMiniReactorValidations = true;
              this.messageAdviceMiniReactorValidations =
                "Llena el formulario de todos los frascos de manera correcta";
              isValid = false;
              break;
            }
            if (!item.concentration) {
              isValid = false;
              this.showAdviceMiniReactorValidations = true;
              this.messageAdviceMiniReactorValidations =
                "Llena el formulario de todos los frascos de manera correcta";
              break;
            } 
            // else if (parseInt(item.concentration) < 0) {
            //   isValid = false;
            //   this.showAdviceMiniReactorValidations = true;
            //   this.messageAdviceMiniReactorValidations =
            //     "Llena el formulario de todos los frascos de manera correcta";
            //   break;
            // }
            if (item.isApproved == undefined) {
              this.showAdviceMiniReactorValidations = true;
              this.messageAdviceMiniReactorValidations =
                "Llena el formulario de todos los frascos de manera correcta";
              isValid = false;
              break;
            }
          }
        } else {
          this.showAdviceMiniReactorValidations = true;
          this.messageAdviceMiniReactorValidations =
            "Llena el formulario de todos los frascos de manera correcta";
        }

        if (isValid) {
          for (let item of this.loteSelected.miniReactorFlasks) {
            if (
              !item.morphology.margin ||
              item.morphology.margin.length == 0 ||
              !item.morphology.elevation ||
              item.morphology.elevation.length == 0 ||
              !item.morphology.surface ||
              item.morphology.surface.length == 0 ||
              !item.morphology.opacity ||
              item.morphology.opacity.length == 0 ||
              !item.morphology.color ||
              item.morphology.color.length == 0
            ) {
              isValid = false;
              this.showAdviceMiniReactorValidations = true;
              this.messageAdviceMiniReactorValidations =
                "Llena el formulario de todos los frascos de manera correcta";
              break;
            }
          }
        }
      }
      if (isValid) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            miniReactorFlasks: this.loteSelected.miniReactorFlasks,
            isDoneValidation: flag,
          };
          let response = await this.saveMRValidation(payload);
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          if (flag) {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Validaciones finalizadas",
              timeout: 3500,
            });
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada",
              timeout: 3500,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal. Error: ${error.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async handleUndoSeed() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoEndSeed(payload);
        this.stepper = 3;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoInoculate() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoFinishInoculate(payload);
        this.stepper = 2;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoFinishPreinoculate() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoFinishPreinoculate(payload);
        this.stepper = 1;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
  watch: {
    "loteSelected.drums": {
      handler: function (val) {
        this.averageDrums = 0;
        this.gapDrums = 0;
        if (val.length > 0) {
          for (let item of val) {
            if (
              item.value != null &&
              item.value != undefined &&
              item.value.length > 0
            ) {
              this.averageDrums += parseFloat(item.value);
            }
          }
          this.averageDrums = (this.averageDrums / val.length).toFixed(2);
          this.gapDrums = 5140.0 - this.averageDrums;
          let minWeight = 4980;
          let maxWeight = 5500;
          this.isValid =
            this.averageDrums >= minWeight && this.averageDrums <= maxWeight;
          this.gapDrums = this.gapDrums.toFixed(2);
        }
      },
      deep: true,
    },
    "loteSelected.flasks": {
      handler: function (val) {
        this.showAdviceMFPreinoculate = false;
      },
      deep: true,
    },
    "loteSelected.jars": {
      handler: function (val) {
        this.showMFAdviceInoculate = false;
      },
      deep: true,
    },
    "loteSelected.jarsSeed": {
      handler: function (val) {
        this.showAdviceMFSeed = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.scroll-row {
  max-height: 200px;
  /* Altura máxima de la fila */
  overflow-y: auto;
  /* Agrega un scroll vertical */
}
</style>
